// import React, { useState, useEffect } from "react";
// // import { GetAgreements } from "../Shared/CommonData/CommonData";
// import { 
//   Home, List, Logout, Map, Print, Report, Handshake,
//   SettingsAccessibility, CheckCircle, Warning, Error,
//   Description, Save, Assignment, Verified, Person,
//   BusinessCenter, CalendarToday, SquareFoot
// } from "@mui/icons-material";
// import {
//   Box,
//   Paper,
//   Typography,
//   InputLabel,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Chip,
//   IconButton,
//   Button,
//   TextField,
//   MenuItem,
//   Select,
//   FormControl,
//   Divider,
//   Grid,
//   Card,
//   CardContent,
//   Tabs,
//   Tab,
//   AppBar,
//   Toolbar,
//   Container,
//   CircularProgress,
//   Input
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// // Import your custom components (adjust paths as needed)
// import FormContainer from "../../../../components/Forms/FormContainer";
// import useDecodedUser from "../../../../services/hooks/useDecodedUser";
// import { ExecutePostWithParams,GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";
// import { AgreementListInPark } from "../../Shared/PreRenderedComponents";
// import { IPDCFormattedJsonToDisplay } from "../../../../components/Controls";

// // ========== STYLED COMPONENTS ==========
// // Times New Roman styled components
// const TimesTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiInputBase-root': {
//     fontFamily: '"Times New Roman", Times, serif',
//     fontSize: '0.875rem',
//     fontWeight: 400,
//   },
//   '& .MuiInputLabel-root': {
//     fontFamily: '"Times New Roman", Times, serif',
//     fontSize: '0.875rem',
//     fontWeight: 400,
//   },
//   '& .MuiOutlinedInput-root': {
//     '& fieldset': {
//       borderWidth: '1px',
//     },
//     '&:hover fieldset': {
//       borderWidth: '1px',
//     },
//     '&.Mui-focused fieldset': {
//       borderWidth: '1px',
//     },
//   },
// }));

// const TimesTypography = styled(Typography)(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif !important',
// }));

// const TimesInput = styled(Input)(({ theme }) => ({
//   '& .MuiInputBase-input': {
//     fontFamily: '"Times New Roman", Times, serif',
//     fontSize: '0.875rem',
//     padding: '8.5px 14px',
//   },
// }));

// const ThinDivider = styled('div')(({ theme }) => ({
//   height: '1px',
//   backgroundColor: '#e0e0e0',
//   margin: '8px 0',
// }));

// // Styled components for checklist table
// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 'bold',
//   backgroundColor: '#f5f5f5',
//   fontFamily: '"Times New Roman", Times, serif',
// }));

// // Tab Panel Component
// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 3 }}>
//           {children}
//         </Box>
//       )}
//     </div>
//   );
// }

// // ========== TAB 1: REGISTER HANDOVER (FROM CODE 1) ==========
// function RegisterHandoverTab({ onHandoverSaved }) {
//   const decodedUser = useDecodedUser();
//   const [formData, setFormData] = useState({
//     agreement_id: "",
//     handover_date: new Date().toISOString().split("T")[0],
//     handedover_by: "",
//     handedover_to: "",
//     notes: "",
//     signed_document_path: "",
//     description: "",
//     park_id: "",
//   });
//   const [selectedAgreement, setSelectedAgreement] = useState(null);
//   const [agreementsList, setAgreementsList] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isUserLoading, setIsUserLoading] = useState(true);

//   useEffect(() => {
//     if (decodedUser) {
//       setIsUserLoading(false);
//       setFormData(prev => ({
//         ...prev,
//         handedover_by: decodedUser.full_name || "",
//         park_id: decodedUser.park_id || ""
//       }));
  
//       const fetchAgreements = async () => {
//         try {
//           const params = { park_id: decodedUser.park_id, type: 'Shed Rent' };
          
//           const agreData = await GetDataFromApiWithParams(`parks/getAgreementByType`, params);
          
//           // Check if agreData is an array
//           const agreDataArray = Array.isArray(agreData) ? agreData : 
//                       (agreData && agreData.data && Array.isArray(agreData.data)) ? agreData.data :
//                       (agreData && typeof agreData === 'object') ? [agreData] : 
//                       [];
            
//             setAgreementsList(agreDataArray);
          
//         } catch (error) {
//           console.error("Error fetching agreements:", error);
//           setAgreementsList([]);
//         }
//       };
      
//       fetchAgreements();
//       console.log("AGREEMENT :",agreementsList)
//     }
//   }, [decodedUser]);

//   const handleChange = (event) => {
//     const { name, value } = event.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setFormData(prev => ({
//         ...prev,
//         signed_document_path: file,
//       }));
//     }
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
    
//     // Validation
//     if (!selectedAgreement?.id) {
//       toast.error("Please select an agreement", { position: "top-right" });
//       return;
//     }
  
//     if (!formData.handedover_to.trim()) {
//       toast.error("Please enter who the handover is being given to", { position: "top-right" });
//       return;
//     }
  
//     setIsLoading(true);
    
//     try {
//       // Create FormData
//       const formDataToSend = new FormData();
      
//       // Add all fields
//       formDataToSend.append("agreement_id", selectedAgreement.id);
//       formDataToSend.append("handover_date", formData.handover_date);
//       formDataToSend.append("handedover_by", decodedUser?.full_name || "");
//       formDataToSend.append("handedover_to", formData.handedover_to);
//       formDataToSend.append("notes", formData.notes || "");
//       formDataToSend.append("description", formData.description || "");
//       formDataToSend.append("park_id", decodedUser?.park_id || "");
      
//       // Add file if exists
//       if (formData.signed_document_path) {
//         formDataToSend.append("file", formData.signed_document_path);
//       }
  
//       // Debug: Log what we're sending
//       console.log("=== DEBUG: Sending to /parks/handover ===");
//       for (let [key, value] of formDataToSend.entries()) {
//         console.log(`${key}:`, value instanceof File ? `File: ${value.name}, ${value.size} bytes` : value);
//       }
      
//       // Call API
//       const result = await ExecutePostWithParams(`parks/handover`, formDataToSend, true);
      
//       if (result) {
//         // toast.success("Handover registered successfully!", { position: "top-right" });
        
//         // Get the handover ID from result
//         const handoverId = result.id || result;
        
//         // Reset form
//         setFormData({
//           agreement_id: "",
//           handover_date: new Date().toISOString().split("T")[0],
//           handedover_by: decodedUser?.full_name || "",
//           handedover_to: "",
//           notes: "",
//           signed_document_path: "",
//           description: "",
//           park_id: decodedUser?.park_id || "",
//         });
//         setSelectedAgreement(null);
        
//         // Reset file input
//         const fileInput = document.querySelector('input[type="file"]');
//         if (fileInput) fileInput.value = '';
        
//         // Notify parent with the handover ID
//         if (onHandoverSaved) {
//           onHandoverSaved(handoverId);
//         }
//       }
//     } catch (error) {
//       console.error("=== SUBMIT ERROR DETAILS ===");
//       console.error("Error message:", error.message);
//       console.error("Error status:", error.response?.status);
//       console.error("Error data:", error.response?.data);
//       console.error("Request URL:", error.config?.url);
//       console.error("=== END ERROR ===");
      
//       let errorMessage = "Failed to register handover";
      
//       if (error.response?.status === 404) {
//         errorMessage = `Endpoint not found: ${error.config?.url}. Please check:
//         1. Is the parkRoutes.js imported in main router?
//         2. Is it mounted as '/parks'?
//         3. Check backend server logs.`;
//       } else if (error.response?.data?.message) {
//         errorMessage = error.response.data.message;
//       } else if (error.message) {
//         errorMessage = error.message;
//       }
      
//       toast.error(errorMessage, { 
//         position: "top-right", 
//         autoClose: 10000 
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   if (isUserLoading) {
//     return (
//       <Container>
//         <Box sx={{ 
//           display: 'flex', 
//           justifyContent: 'center', 
//           alignItems: 'center', 
//           height: '100vh',
//           fontFamily: '"Times New Roman", Times, serif'
//         }}>
//           <CircularProgress size={24} />
//           <TimesTypography sx={{ ml: 2, fontSize: '0.875rem' }}>Loading...</TimesTypography>
//         </Box>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>
//       <ToastContainer 
//         toastStyle={{ fontFamily: '"Times New Roman", Times, serif' }}
//       />
      
//       <FormContainer 
//         title="Register Handover Details" 
//         onSubmit={handleSubmit}
//         sx={{ 
//           fontFamily: '"Times New Roman", Times, serif',
//           '& .MuiTypography-h4, & .MuiTypography-h5, & .MuiTypography-h6': {
//             fontFamily: '"Times New Roman", Times, serif !important',
//           }
//         }}
//         titleSx={{
//           fontFamily: '"Times New Roman", Times, serif',
//           fontSize: '1.25rem',
//           fontWeight: 400,
//           letterSpacing: '0.5px',
//           color: '#333',
//           textTransform: 'none',
//         }}
//       >
//         <Grid container spacing={1.5}>
//           <Grid item xs={12} md={6}>
//             <Grid container spacing={1.5}>
//               <Grid item xs={12}>
                
//   <FormControl fullWidth size="small" sx={{ mb: 1 }}>
//   <InputLabel 
//     sx={{ 
//       fontFamily: '"Times New Roman", Times, serif',
//       fontSize: '0.8rem'
//     }}
//   >
//     Select Agreement
//   </InputLabel>
//   <Select
//     value={selectedAgreement ? selectedAgreement.id : ''}
//     onChange={(e) => {
//       const selectedId = e.target.value;
//       // Find the full agreement object from your agreements list
//       const agreement = agreementsList.find(ag => ag.id === selectedId);
//       setSelectedAgreement(agreement || null);
//     }}
//     label="Select Agreement"
//     sx={{
//       fontFamily: '"Times New Roman", Times, serif',
//       fontSize: '0.8rem',
//       height: '32px',
//       '& .MuiSelect-select': {
//         padding: '6px 10px',
//       }
//     }}
//   >
//     <MenuItem value="" sx={{ fontFamily: '"Times New Roman", Times, serif', fontSize: '0.8rem' }}>
//       <em>None</em>
//     </MenuItem>
//     {agreementsList.map((agreement) => (
//       <MenuItem 
//         key={agreement.id} 
//         value={agreement.id}
//         sx={{ 
//           fontFamily: '"Times New Roman", Times, serif',
//           fontSize: '0.8rem',
//           whiteSpace: 'normal',
//           py: 0.5
//         }}
//       >
//         {agreement?.name || agreement?.agreement_no || agreement?.id}
//       </MenuItem>
//     ))}
//   </Select>
// </FormControl>
//                 <ThinDivider />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Handover Date"
//                   type="date"
//                   name="handover_date"
//                   fullWidth
//                   size="small"
//                   InputLabelProps={{ 
//                     shrink: true,
//                     style: { 
//                       fontFamily: '"Times New Roman", Times, serif', 
//                       fontSize: '0.8125rem',
//                       fontWeight: 400
//                     }
//                   }}
//                   inputProps={{
//                     style: { 
//                       fontFamily: '"Times New Roman", Times, serif',
//                       fontSize: '0.8125rem',
//                       fontWeight: 400,
//                       padding: '5.5px 14px 5.5px 0'
//                     }
//                   }}
//                   value={formData.handover_date}
//                   onChange={handleChange}
//                   required
//                   disabled={isLoading}
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Handed Over By"
//                   name="handedover_by"
//                   fullWidth
//                   size="small"
//                   InputLabelProps={{ 
//                     style: { 
//                       fontFamily: '"Times New Roman", Times, serif', 
//                       fontSize: '0.8125rem',
//                       fontWeight: 400
//                     }
//                   }}
//                   inputProps={{
//                     style: { 
//                       fontFamily: '"Times New Roman", Times, serif',
//                       fontSize: '0.8125rem',
//                       fontWeight: 400
//                     }
//                   }}
//                   value={formData.handedover_by}
//                   disabled
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Handed Over To "
//                   name="handedover_to"
//                   fullWidth
//                   size="small"
//                   InputLabelProps={{ 
//                     style: { 
//                       fontFamily: '"Times New Roman", Times, serif', 
//                       fontSize: '0.8125rem',
//                       fontWeight: 400
//                     }
//                   }}
//                   inputProps={{
//                     style: { 
//                       fontFamily: '"Times New Roman", Times, serif',
//                       fontSize: '0.8125rem',
//                       fontWeight: 400
//                     }
//                   }}
//                   value={formData.handedover_to}
//                   onChange={handleChange}
//                   required
//                   disabled={isLoading}
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Notes"
//                   name="notes"
//                   fullWidth
//                   size="small"
//                   InputLabelProps={{ 
//                     style: { 
//                       fontFamily: '"Times New Roman", Times, serif', 
//                       fontSize: '0.8125rem',
//                       fontWeight: 400
//                     }
//                   }}
//                   inputProps={{
//                     style: { 
//                       fontFamily: '"Times New Roman", Times, serif',
//                       fontSize: '0.8125rem',
//                       fontWeight: 400
//                     }
//                   }}
//                   value={formData.notes}
//                   onChange={handleChange}
//                   disabled={isLoading}
//                   multiline
//                   rows={1}
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTypography 
//                   variant="subtitle2" 
//                   sx={{ 
//                     mb: 0.5, 
//                     fontWeight: 400,
//                     fontSize: '0.8125rem',
//                     fontFamily: '"Times New Roman", Times, serif'
//                   }}
//                 >
//                   Signed Document 
//                 </TimesTypography>
//                 <TimesInput
//                   type="file"
//                   fullWidth
//                   size="small"
//                   disabled={isLoading}
//                   inputProps={{ 
//                     accept: "application/pdf,image/*",
//                     // required: true,
//                     style: { 
//                       fontFamily: '"Times New Roman", Times, serif',
//                       fontSize: '0.8125rem',
//                       fontWeight: 400,
//                       padding: '5.5px 14px'
//                     }
//                   }}
//                   onChange={handleFileChange}
//                   sx={{ 
//                     '& .MuiInputBase-root': { 
//                       padding: '0 !important',
//                       fontFamily: '"Times New Roman", Times, serif'
//                     }
//                   }}
//                 />
//                 <TimesTypography 
//                   variant="caption" 
//                   color="textSecondary" 
//                   sx={{ 
//                     mt: 0.5, 
//                     display: 'block',
//                     fontSize: '0.75rem',
//                     fontWeight: 300,
//                     fontFamily: '"Times New Roman", Times, serif'
//                   }}
//                 >
//                   Accepts PDF or image files
//                 </TimesTypography>
//                 <ThinDivider />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TimesTextField
//                   label="Description"
//                   name="description"
//                   fullWidth
//                   size="small"
//                   InputLabelProps={{ 
//                     style: { 
//                       fontFamily: '"Times New Roman", Times, serif', 
//                       fontSize: '0.8125rem',
//                       fontWeight: 400
//                     }
//                   }}
//                   inputProps={{
//                     style: { 
//                       fontFamily: '"Times New Roman", Times, serif',
//                       fontSize: '0.8125rem',
//                       fontWeight: 400
//                     }
//                   }}
//                   value={formData.description}
//                   onChange={handleChange}
//                   disabled={isLoading}
//                   multiline
//                   rows={2}
//                 />
//               </Grid>

//               {/* <Grid item xs={12}>
//                 <Button 
//                   type="submit"
//                   variant="contained" 
//                   color="primary"
//                   fullWidth
//                   disabled={isLoading}
//                   startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <Save />}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                 >
//                   {isLoading ? "Saving..." : "Register Handover"}
//                 </Button>
//               </Grid> */}
//             </Grid>
//           </Grid>
          
//           <Grid item xs={12} md={6}>
//             <Box sx={{ 
//               height: "100%", 
//               border: '1px solid #e0e0e0', 
//               borderRadius: 0.5, 
//               p: 1.5,
//               backgroundColor: '#fafafa'
//             }}>
//               <TimesTypography 
//                 variant="h6" 
//                 align="center" 
//                 gutterBottom
//                 sx={{ 
//                   fontSize: '0.9375rem',
//                   fontWeight: 300,
//                   mb: 1.5,
//                   fontFamily: '"Times New Roman", Times, serif',
//                   letterSpacing: '0.3px',
//                   color: '#555',
//                   textTransform: 'uppercase'
//                 }}
//               >
//                 Agreement Details
//               </TimesTypography>
              
//               {selectedAgreement ? (
//                 <Box sx={{ 
//                   height: '450px', 
//                   overflow: 'auto',
//                   '& *': {
//                     fontFamily: '"Times New Roman", Times, serif !important',
//                     fontSize: '0.8125rem !important',
//                     fontWeight: '300 !important',
//                   }
//                 }}>
//                   <IPDCFormattedJsonToDisplay 
//                     data={selectedAgreement} 
//                     height="450px"
//                     sx={{ 
//                       fontFamily: '"Times New Roman", Times, serif',
//                       fontSize: '0.8125rem',
//                       fontWeight: 300
//                     }}
//                   />
//                 </Box>
//               ) : (
//                 <Box sx={{ 
//                   display: 'flex', 
//                   justifyContent: 'center', 
//                   alignItems: 'center', 
//                   height: '450px',
//                   border: '1px dashed #bdbdbd',
//                   borderRadius: 0.5,
//                   backgroundColor: '#ffffff'
//                 }}>
//                   <TimesTypography 
//                     color="textSecondary" 
//                     sx={{ 
//                       fontSize: '0.8125rem', 
//                       fontStyle: 'italic',
//                       fontWeight: 300,
//                       fontFamily: '"Times New Roman", Times, serif'
//                     }}
//                   >
//                     Select an agreement *
//                   </TimesTypography>
//                 </Box>
//               )}
//             </Box>
//           </Grid>
          
//           <Grid item xs={12}>
//             {isLoading && (
//               <Box sx={{ 
//                 display: 'flex', 
//                 justifyContent: 'center', 
//                 alignItems: 'center', 
//                 mt: 1,
//                 fontFamily: '"Times New Roman", Times, serif'
//               }}>
//                 <CircularProgress size={18} sx={{ color: '#666' }} />
//                 <TimesTypography 
//                   sx={{ 
//                     ml: 1.5, 
//                     fontSize: '0.8125rem',
//                     fontWeight: 300,
//                     color: '#666',
//                     fontFamily: '"Times New Roman", Times, serif'
//                   }}
//                 >
//                   Registering handover...
//                 </TimesTypography>
//               </Box>
//             )}
//           </Grid>
//         </Grid>
//       </FormContainer>
//     </Container>
//   );
// }

// // ========== TAB 2: COMPLETE SHED CHECKLIST (FROM CODE 2) ==========
// function CombinedChecklistTab({ handoverId, onSave }) {
//   const [checklistItems, setChecklistItems] = useState([
//     { no: 1, item: "Exterior Walls and painting", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 2, item: "Interior Walls and painting", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 3, item: "Interior Partition Walls", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 4, item: "Doors and key", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 5, item: "Stair Case and corridor", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 6, item: "Shutter Doors and Remote control", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 7, item: "Flooring", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 8, item: "Asphalt and Access Roads", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 9, item: "Skirting", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 10, item: "Entrances And Exits way", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 11, item: "Truck Service Ways asphalt", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 12, item: "Roof", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 13, item: "Window and glass", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 14, item: "Aluminum door and glass", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 15, item: "Landscape area", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 16, item: "Ceiling", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 17, item: "Lights", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 18, item: "Switch", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 19, item: "Power Breakers", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 20, item: "Emergency Lights", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 21, item: "Exit Lights", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 22, item: "UPS battery monitoring unit", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 23, item: "Water Supply", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 24, item: "Toilet and Flushers", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 25, item: "Hand Wash and faucet", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 26, item: "Toilet floor drain", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 27, item: "Fire Hydrant Accessories", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 28, item: "Fire Alarm Control Panel", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 29, item: "Fire Sprinkler System Devices", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 30, item: "Fire Hydrant Hose", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 31, item: "Fire Extinguisher", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 32, item: "Telecom switch", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 33, item: "Telephone Lines", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 34, item: "Telecom Ports", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 35, item: "Electric Wire Installation", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 36, item: "Power Supply Panels", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 37, item: "Transformer", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 38, item: "Power meter reading", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 39, item: "Water Meter Readings", status: "", acceptReject: "Pending", remarks: "" },
//     { no: 40, item: "Other (if any)", status: "", acceptReject: "Pending", remarks: "" },
   
//   ].sort((a, b) => a.no - b.no));

//   const [signatures, setSignatures] = useState({
//     ipdc_vice_name: "",
//     ipdc_vice_position: "",
//     ipdc_vice_signature: "",
//     ipdc_vice_date: "",
//     investor_name: "",
//     investor_position: "",
//     investor_signature: "",
//     investor_date: "",
//     ipdc_kisez_name: "",
//     ipdc_kisez_position: "",
//     ipdc_kisez_signature: "",
//     ipdc_kisez_date: "",
//     // Witness fields
//     witness1_name: "",
//     witness2_name: "",
//     witness3_name: ""
//   });

//   const [isSaving, setIsSaving] = useState(false);

//   const handleStatusChange = (no, newStatus) => {
//     setChecklistItems(prevItems =>
//       prevItems.map(item =>
//         item.no === no ? { ...item, status: newStatus } : item
//       )
//     );
//   };

//   const handleAcceptRejectChange = (no, newValue) => {
//     setChecklistItems(prevItems =>
//       prevItems.map(item =>
//         item.no === no ? { ...item, acceptReject: newValue } : item
//       )
//     );
//   };

//   const handleRemarksChange = (no, newRemarks) => {
//     setChecklistItems(prevItems =>
//       prevItems.map(item =>
//         item.no === no ? { ...item, remarks: newRemarks } : item
//       )
//     );
//   };

//   const handleSignatureChange = (field, value) => {
//     setSignatures(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const handleSaveChecklist = async () => {
//     if (!handoverId) {
//       toast.error("Please save handover details first", { position: "top-right" });
//       return;
//     }
  
//     setIsSaving(true);
    
//     try {
//       // Save signatures with witnesses included
//       const signatureData = {
//         handover_id: handoverId,
//         ...signatures
//       };
  
//       await ExecutePostWithParams(`parks/shed-inspection-signatures`, signatureData);
  
//       // Save all checklist items in a single API call
//       const checklistData = {
//         handover_id: handoverId,
//         checklist_items: checklistItems.map(item => ({
//           inspection_no: item.no,
//           item_name: item.item,
//           status: item.status || '',
//           accept_reject: item.acceptReject || 'Pending',
//           remarks: item.remarks || ''
//         }))
//       };
  
//       await ExecutePostWithParams(`parks/handover-checklist-items`, checklistData);
  
//       // toast.success("Checklist saved successfully!", { position: "top-right" });
      
//       if (onSave) {
//         onSave();
//       }
//     } catch (error) {
//       console.error("Error saving checklist:", error);
//       toast.error("Failed to save checklist", { position: "top-right" });
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   return (
//     <Paper elevation={3} sx={{ p: 2, fontFamily: '"Times New Roman", Times, serif' }}>
//       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//         <Assignment sx={{ mr: 1, color: 'primary.main' }} />
//         <Typography variant="h5" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>
//           Complete Shed Inspection Checklist
//         </Typography>
//       </Box>
      
//       <TableContainer component={Paper} elevation={1} sx={{ maxHeight: 500 }}>
//         <Table stickyHeader>
//           <TableHead>
//             <TableRow>
//               <StyledTableCell>No.</StyledTableCell>
//               <StyledTableCell>LIST TO BE INSPECTED</StyledTableCell>
//               <StyledTableCell>STATUS</StyledTableCell>
//               <StyledTableCell>ACCEPT/REJECT</StyledTableCell>
//               <StyledTableCell>REMARKS</StyledTableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {checklistItems.map((row) => (
//               <TableRow key={row.no} hover>
//                 <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{row.no}</TableCell>
//                 <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{row.item}</TableCell>
//                 <TableCell>
//                   <TextField
//                     size="small"
//                     fullWidth
//                     multiline
//                     minRows={2}
//                     maxRows={4}
//                     value={row.status || ''}
//                     onChange={(e) => handleStatusChange(row.no, e.target.value)}
//                     placeholder="Enter status"
//                     sx={{ 
//                       fontFamily: '"Times New Roman", Times, serif',
//                       '& .MuiInputBase-root': {
//                         fontFamily: '"Times New Roman", Times, serif',
//                         fontSize: '0.875rem'
//                       }
//                     }}
//                   />
//                 </TableCell>
//                 <TableCell>
//                   <FormControl size="small" fullWidth>
//                     <Select
//                       value={row.acceptReject}
//                       onChange={(e) => handleAcceptRejectChange(row.no, e.target.value)}
//                       displayEmpty
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         fontSize: '0.875rem',
//                         minWidth: 100
//                       }}
//                     >
//                       <MenuItem value="Accept" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Accept</MenuItem>
//                       <MenuItem value="Reject" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Reject</MenuItem>
//                       <MenuItem value="Pending" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Pending</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </TableCell>
//                 <TableCell>
//                   <TextField
//                     size="small"
//                     fullWidth
//                     multiline
//                     minRows={2}
//                     maxRows={4}
//                     value={row.remarks}
//                     onChange={(e) => handleRemarksChange(row.no, e.target.value)}
//                     placeholder="Enter remarks"
//                     sx={{ 
//                       fontFamily: '"Times New Roman", Times, serif',
//                       '& .MuiInputBase-root': {
//                         fontFamily: '"Times New Roman", Times, serif',
//                         fontSize: '0.875rem'
//                       }
//                     }}
//                   />
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <Box sx={{ mt: 4 }}>
//         <Typography variant="h6" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif' }}>
//           Signatures
//         </Typography>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={4}>
//             <Card variant="outlined">
//               <CardContent>
//                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                   <Person sx={{ mr: 1, color: 'primary.main' }} />
//                   <Typography variant="subtitle1" fontWeight="bold" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>
//                     IPDC Vice E & Technic Manager
//                   </Typography>
//                 </Box>
//                 <Divider sx={{ my: 1 }} />
//                 <Grid container spacing={1}>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Name"
//                       value={signatures.ipdc_vice_name}
//                       onChange={(e) => handleSignatureChange('ipdc_vice_name', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Position"
//                       value={signatures.ipdc_vice_position}
//                       onChange={(e) => handleSignatureChange('ipdc_vice_position', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       type="password"
//                       label="Secrete key"
//                       value={signatures.ipdc_vice_signature}
//                       onChange={(e) => handleSignatureChange('ipdc_vice_signature', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       type="date"
//                       label="Date"
//                       required
//                       InputLabelProps={{ 
//                         shrink: true,
//                         sx: {
//                           '& .MuiInputLabel-asterisk': {
//                             color: 'red'
//                           }
//                         }
//                       }}
//                       value={signatures.ipdc_vice_date}
//                       onChange={(e) => handleSignatureChange('ipdc_vice_date', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </CardContent>
//             </Card>
//           </Grid>
          
//           <Grid item xs={12} md={4}>
//             <Card variant="outlined">
//               <CardContent>
//                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                   <Handshake sx={{ mr: 1, color: 'primary.main' }} />
//                   <Typography variant="subtitle1" fontWeight="bold" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>
//                     Investor Company
//                   </Typography>
//                 </Box>
//                 <Divider sx={{ my: 1 }} />
//                 <Grid container spacing={1}>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Name"
//                       value={signatures.investor_name}
//                       onChange={(e) => handleSignatureChange('investor_name', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Position"
//                       value={signatures.investor_position}
//                       onChange={(e) => handleSignatureChange('investor_position', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       type="password"
//                       label="Secret key"
//                       value={signatures.investor_signature}
//                       onChange={(e) => handleSignatureChange('investor_signature', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       type="date"
//                       label="Date"
//                       required
//                       InputLabelProps={{ 
//                         shrink: true,
//                         sx: {
//                           '& .MuiInputLabel-asterisk': {
//                             color: 'red'
//                           }
//                         }
//                       }}
//                       value={signatures.investor_date}
//                       onChange={(e) => handleSignatureChange('investor_date', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </CardContent>
//             </Card>
//           </Grid>
          
//           <Grid item xs={12} md={4}>
//             <Card variant="outlined">
//               <CardContent>
//                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                   <Person sx={{ mr: 1, color: 'primary.main' }} />
//                   <Typography variant="subtitle1" fontWeight="bold" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>
//                     IPDC KISEZ Manager
//                   </Typography>
//                 </Box>
//                 <Divider sx={{ my: 1 }} />
//                 <Grid container spacing={1}>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Name"
//                       value={signatures.ipdc_kisez_name}
//                       onChange={(e) => handleSignatureChange('ipdc_kisez_name', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Position"
//                       value={signatures.ipdc_kisez_position}
//                       onChange={(e) => handleSignatureChange('ipdc_kisez_position', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       type="password"
//                       label="Secret key"
//                       value={signatures.ipdc_kisez_signature}
//                       onChange={(e) => handleSignatureChange('ipdc_kisez_signature', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       type="date"
//                       label="Date"
//                       required
//                       InputLabelProps={{ 
//                         shrink: true,
//                         sx: {
//                           '& .MuiInputLabel-asterisk': {
//                             color: 'red'
//                           }
//                         }
//                       }}
//                       value={signatures.ipdc_kisez_date}
//                       onChange={(e) => handleSignatureChange('ipdc_kisez_date', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </CardContent>
//             </Card>
//           </Grid>

//           {/* Witness Card */}
//           <Grid item xs={12} md={4}>
//             <Card variant="outlined">
//               <CardContent>
//                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                   <Person sx={{ mr: 1, color: 'primary.main' }} />
//                   <Typography variant="subtitle1" fontWeight="bold" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>
//                     Witness
//                   </Typography>
//                 </Box>
//                 <Divider sx={{ my: 1 }} />
//                 <Grid container spacing={1}>
//                   <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     1.
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Name"
//                       value={signatures.witness1_name}
//                       onChange={(e) => handleSignatureChange('witness1_name', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     2.
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Name"
//                       value={signatures.witness2_name}
//                       onChange={(e) => handleSignatureChange('witness2_name', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     3.
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Name"
//                       value={signatures.witness3_name}
//                       onChange={(e) => handleSignatureChange('witness3_name', e.target.value)}
//                       sx={{ 
//                         fontFamily: '"Times New Roman", Times, serif',
//                         '& .MuiInputBase-root': { fontFamily: '"Times New Roman", Times, serif' },
//                         '& .MuiInputLabel-root': { fontFamily: '"Times New Roman", Times, serif' }
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>
//       </Box>

//       <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//       <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', mt: 3 }}>
//             <Button 
//               variant="contained" 
//               color="primary"
//               startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : <Save />}
//               onClick={handleSaveChecklist}
//               disabled={isSaving || !handoverId}
//               size="large"
//               sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//             >
//               {isSaving ? "Saving..." : "Save Inspection Checklist"}
//             </Button>
            
//             {!handoverId && (
//               <Typography 
//                 sx={{ 
//                   color: 'error.main', 
//                   fontSize: '0.875rem', 
//                   mt: 1,  // margin top to create space between button and text
//                   fontFamily: '"Times New Roman", Times, serif'
//                 }}
//               >
//                 To enable this button, register handover first
//               </Typography>
//             )}
//           </Box>
   
//       </Box>
//     </Paper>
//   );
// }

// // ========== MAIN COMPONENT WITH TABS ==========
// export default function InspectionManagement() {
//   const [tabValue, setTabValue] = useState(0);
//   const [currentHandoverId, setCurrentHandoverId] = useState(null);

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//   const handleHandoverSaved = (handoverId) => {
//     setCurrentHandoverId(handoverId);
//     toast.success("Handover registered successfully! Handover saved! You can now fill the checklist.", { position: "top-right" });
//   };

//   const handleChecklistSaved = () => {
//     toast.success("All data saved successfully!", { position: "top-right" });
//   };

//   return (
//     <Box sx={{ flexGrow: 1 }}>
//       <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
//         <Tabs value={tabValue} onChange={handleTabChange} aria-label="inspection tabs">
//           <Tab 
//             icon={<Verified />} 
//             label="Register Handover" 
//             iconPosition="start"
//             sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//           />
//           <Tab 
//             icon={<Assignment />} 
//             label="Complete Shed Checklist" 
//             iconPosition="start"
//             sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//           />
//         </Tabs>
//       </Box>

//       <TabPanel value={tabValue} index={0}>
//         <RegisterHandoverTab onHandoverSaved={handleHandoverSaved} />
//       </TabPanel>

//       <TabPanel value={tabValue} index={1}>
//         <CombinedChecklistTab 
//           handoverId={currentHandoverId} 
//           onSave={handleChecklistSaved}
//         />
//       </TabPanel>
//     </Box>
//   );
// }
//******************************************************************************** */
import React, { useState, useEffect, useRef } from "react";
// import { GetAgreements } from "../Shared/CommonData/CommonData";
import { 
  Home, List, Logout, Map, Print, Report, Handshake,
  SettingsAccessibility, CheckCircle, Warning, Error,
  Description, Save, Assignment, Verified, Person,
  BusinessCenter, CalendarToday, SquareFoot,
  Download
} from "@mui/icons-material";
import {
  Box,
  Paper,
  Typography,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  Divider,
  Grid,
  Card,
  CardContent,
  Tabs,
  Tab,
  AppBar,
  Toolbar,
  Container,
  CircularProgress,
  Input
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Import your custom components (adjust paths as needed)
import FormContainer from "../../../../components/Forms/FormContainer";
import useDecodedUser from "../../../../services/hooks/useDecodedUser";
import { ExecutePostWithParams,GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";
import { AgreementListInPark } from "../../Shared/PreRenderedComponents";
import { IPDCFormattedJsonToDisplay } from "../../../../components/Controls";

// Use public folder path for logo
const IPDCLogo = "/IPDC_LOGO.jpg";
const EthiopiaLogo = "/et logo.png";

// ========== STYLED COMPONENTS ==========
const TimesTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    fontFamily: '"Times New Roman", Times, serif',
    fontSize: '0.85rem',
    fontWeight: 400,
  },
  '& .MuiInputLabel-root': {
    fontFamily: '"Times New Roman", Times, serif',
    fontSize: '0.85rem',
    fontWeight: 400,
  },
}));

const TimesTypography = styled(Typography)(({ theme }) => ({
  fontFamily: '"Times New Roman", Times, serif !important',
}));

const ThinDivider = styled('div')(({ theme }) => ({
  height: '1px',
  backgroundColor: '#e0e0e0',
  margin: '8px 0',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f5f5f5',
  fontFamily: '"Times New Roman", Times, serif',
  fontSize: '0.8rem',
  padding: '6px 8px',
}));

// Print styles - ensures content fits on two pages with proper page breaks
const PrintStyle = () => (
  <style type="text/css" media="print">
    {`
      @media print {
        .no-print {
          display: none !important;
        }
        .print-only {
          display: block !important;
        }
        .print-header {
          display: block !important;
        }
        body {
          margin: 0;
          padding: 0;
        }
        * {
          box-sizing: border-box;
        }
        .MuiPaper-root {
          box-shadow: none !important;
          border: none !important;
        }
        button, .MuiButton-root, .MuiIconButton-root, .MuiTabs-root, .MuiTab-root, .MuiAppBar-root, header, nav, .sidebar, .MuiDrawer-root, .MuiToolbar-root {
          display: none !important;
        }
        @page {
          size: A4;
          margin: 0.8cm;
        }
        
        /* Better spacing */
        .MuiTypography-root, p, div, span, .MuiTableCell-root {
          line-height: 1.15 !important;
        }
        
        .MuiTableRow-root {
          line-height: 1.15 !important;
        }
        
        .MuiTableCell-root {
          padding: 3px 5px !important;
          font-size: 12pt !important;
        }
        
        .MuiTable-root {
          margin-bottom: 3px !important;
        }
        
        /* Force table to fit */
        .MuiTableContainer-root {
          overflow: visible !important;
          max-height: none !important;
        }
        
        table {
          width: 100% !important;
        }
        
        /* Page break controls */
        .page-break-before {
          page-break-before: always;
        }
        
        /* Column widths */
        .print-table td:nth-child(1), .print-table th:nth-child(1) { width: 6% !important; }
        .print-table td:nth-child(2), .print-table th:nth-child(2) { width: 32% !important; }
        .print-table td:nth-child(3), .print-table th:nth-child(3) { width: 20% !important; }
        .print-table td:nth-child(4), .print-table th:nth-child(4) { width: 16% !important; }
        .print-table td:nth-child(5), .print-table th:nth-child(5) { width: 26% !important; }
      }
    `}
  </style>
);

function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} {...other}>
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

// ========== TAB 1: REGISTER HANDOVER ==========
function RegisterHandoverTab({ onHandoverSaved }) {
  const decodedUser = useDecodedUser();
  const [formData, setFormData] = useState({
    agreement_id: "",
    handover_date: new Date().toISOString().split("T")[0],
    handedover_by: "",
    handedover_to: "",
    notes: "",
    signed_document_path: "",
    description: "",
    park_id: "",
  });
  const [selectedAgreement, setSelectedAgreement] = useState(null);
  const [agreementsList, setAgreementsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isUserLoading, setIsUserLoading] = useState(true);

  useEffect(() => {
    if (decodedUser) {
      setIsUserLoading(false);
      setFormData(prev => ({
        ...prev,
        handedover_by: decodedUser.full_name || "",
        park_id: decodedUser.park_id || ""
      }));
  
      const fetchAgreements = async () => {
        try {
          const params = { park_id: decodedUser.park_id, type: 'Shed Rent' };
          const agreData = await GetDataFromApiWithParams(`parks/getAgreementByType`, params);
          const agreDataArray = Array.isArray(agreData) ? agreData : 
                      (agreData && agreData.data && Array.isArray(agreData.data)) ? agreData.data : [];
          setAgreementsList(agreDataArray);
        } catch (error) {
          console.error("Error fetching agreements:", error);
          setAgreementsList([]);
        }
      };
      fetchAgreements();
    }
  }, [decodedUser]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) setFormData(prev => ({ ...prev, signed_document_path: file }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!selectedAgreement?.id) {
      toast.error("Please select an agreement");
      return;
    }
    if (!formData.handedover_to.trim()) {
      toast.error("Please enter who the handover is being given to");
      return;
    }
  
    setIsLoading(true);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("agreement_id", selectedAgreement.id);
      formDataToSend.append("handover_date", formData.handover_date);
      formDataToSend.append("handedover_by", decodedUser?.full_name || "");
      formDataToSend.append("handedover_to", formData.handedover_to);
      formDataToSend.append("notes", formData.notes || "");
      formDataToSend.append("description", formData.description || "");
      formDataToSend.append("park_id", decodedUser?.park_id || "");
      if (formData.signed_document_path) formDataToSend.append("file", formData.signed_document_path);
      
      const result = await ExecutePostWithParams(`parks/handover`, formDataToSend, true);
      if (result) {
        const handoverId = result.id || result;
        setFormData({
          agreement_id: "",
          handover_date: new Date().toISOString().split("T")[0],
          handedover_by: decodedUser?.full_name || "",
          handedover_to: "",
          notes: "",
          signed_document_path: "",
          description: "",
          park_id: decodedUser?.park_id || "",
        });
        setSelectedAgreement(null);
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) fileInput.value = '';
        if (onHandoverSaved) onHandoverSaved(handoverId, selectedAgreement);
        toast.success("Handover registered successfully!");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to register handover");
    } finally {
      setIsLoading(false);
    }
  };

  if (isUserLoading) {
    return (
      <Container>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress size={24} />
          <TimesTypography sx={{ ml: 2 }}>Loading...</TimesTypography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      <ToastContainer />
      <FormContainer title="Register Handover Details" onSubmit={handleSubmit}>
        <Grid container spacing={1.5}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small" sx={{ mb: 1 }}>
              <InputLabel>Select Agreement</InputLabel>
              <Select
                value={selectedAgreement ? selectedAgreement.id : ''}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const agreement = agreementsList.find(ag => ag.id === selectedId);
                  setSelectedAgreement(agreement || null);
                }}
                label="Select Agreement"
              >
                <MenuItem value="">None</MenuItem>
                {agreementsList.map((agreement) => (
                  <MenuItem key={agreement.id} value={agreement.id}>
                    {agreement?.name || agreement?.agreement_no || agreement?.id}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TimesTextField
              label="Handover Date"
              type="date"
              name="handover_date"
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
              value={formData.handover_date}
              onChange={handleChange}
              required
              disabled={isLoading}
              sx={{ mb: 1 }}
            />
            <TimesTextField
              label="Handed Over By"
              name="handedover_by"
              fullWidth
              size="small"
              value={formData.handedover_by}
              disabled
              sx={{ mb: 1 }}
            />
            <TimesTextField
              label="Handed Over To"
              name="handedover_to"
              fullWidth
              size="small"
              value={formData.handedover_to}
              onChange={handleChange}
              required
              disabled={isLoading}
              sx={{ mb: 1 }}
            />
            <TimesTextField
              label="Notes"
              name="notes"
              fullWidth
              size="small"
              value={formData.notes}
              onChange={handleChange}
              disabled={isLoading}
              multiline
              rows={1}
              sx={{ mb: 1 }}
            />
            <TimesTypography variant="subtitle2">Signed Document</TimesTypography>
            <Input type="file" fullWidth disabled={isLoading} inputProps={{ accept: "application/pdf,image/*" }} onChange={handleFileChange} />
            <TimesTextField
              label="Description"
              name="description"
              fullWidth
              size="small"
              value={formData.description}
              onChange={handleChange}
              disabled={isLoading}
              multiline
              rows={2}
              sx={{ mt: 1 }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ border: '1px solid #e0e0e0', p: 1.5, bgcolor: '#fafafa', minHeight: '400px' }}>
              <TimesTypography variant="h6" align="center">Agreement Details</TimesTypography>
              {selectedAgreement ? (
                <Box sx={{ height: '400px', overflow: 'auto' }}>
                  <IPDCFormattedJsonToDisplay data={selectedAgreement} height="400px" />
                </Box>
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px', border: '1px dashed #bdbdbd' }}>
                  <TimesTypography color="textSecondary">Select an agreement *</TimesTypography>
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={isLoading} startIcon={isLoading ? <CircularProgress size={20} /> : <Save />}>
              {isLoading ? "Saving..." : "Register Handover"}
            </Button>
          </Grid>
        </Grid>
      </FormContainer>
    </Container>
  );
}

// ========== TAB 2: COMPLETE SHED CHECKLIST ==========
function CombinedChecklistTab({ handoverId, onSave, selectedAgreement }) {
  const [checklistItems, setChecklistItems] = useState([
    { no: 1, item: "Exterior Walls and painting", status: "", acceptReject: "Pending", remarks: "" },
    { no: 2, item: "Interior Walls and painting", status: "", acceptReject: "Pending", remarks: "" },
    { no: 3, item: "Interior Partition Walls", status: "", acceptReject: "Pending", remarks: "" },
    { no: 4, item: "Doors and key", status: "", acceptReject: "Pending", remarks: "" },
    { no: 5, item: "Stair Case and corridor", status: "", acceptReject: "Pending", remarks: "" },
    { no: 6, item: "Shutter Doors and Remote control", status: "", acceptReject: "Pending", remarks: "" },
    { no: 7, item: "Flooring", status: "", acceptReject: "Pending", remarks: "" },
    { no: 8, item: "Asphalt and Access Roads", status: "", acceptReject: "Pending", remarks: "" },
    { no: 9, item: "Skirting", status: "", acceptReject: "Pending", remarks: "" },
    { no: 10, item: "Entrances And Exits way", status: "", acceptReject: "Pending", remarks: "" },
    { no: 11, item: "Truck Service Ways asphalt", status: "", acceptReject: "Pending", remarks: "" },
    { no: 12, item: "Roof", status: "", acceptReject: "Pending", remarks: "" },
    { no: 13, item: "Window and glass", status: "", acceptReject: "Pending", remarks: "" },
    { no: 14, item: "Aluminum door and glass", status: "", acceptReject: "Pending", remarks: "" },
    { no: 15, item: "Landscape area", status: "", acceptReject: "Pending", remarks: "" },
    { no: 16, item: "Ceiling", status: "", acceptReject: "Pending", remarks: "" },
    { no: 17, item: "Lights", status: "", acceptReject: "Pending", remarks: "" },
    { no: 18, item: "Switch", status: "", acceptReject: "Pending", remarks: "" },
    { no: 19, item: "Power Breakers", status: "", acceptReject: "Pending", remarks: "" },
    { no: 20, item: "Emergency Lights", status: "", acceptReject: "Pending", remarks: "" },
    { no: 21, item: "Exit Lights", status: "", acceptReject: "Pending", remarks: "" },
    { no: 22, item: "UPS battery monitoring unit", status: "", acceptReject: "Pending", remarks: "" },
    { no: 23, item: "Water Supply", status: "", acceptReject: "Pending", remarks: "" },
    { no: 24, item: "Toilet and Flushers", status: "", acceptReject: "Pending", remarks: "" },
    { no: 25, item: "Hand Wash and faucet", status: "", acceptReject: "Pending", remarks: "" },
    { no: 26, item: "Toilet floor drain", status: "", acceptReject: "Pending", remarks: "" },
    { no: 27, item: "Fire Hydrant Accessories", status: "", acceptReject: "Pending", remarks: "" },
    { no: 28, item: "Fire Alarm Control Panel", status: "", acceptReject: "Pending", remarks: "" },
    { no: 29, item: "Fire Sprinkler System Devices", status: "", acceptReject: "Pending", remarks: "" },
    { no: 30, item: "Fire Hydrant Hose", status: "", acceptReject: "Pending", remarks: "" },
    { no: 31, item: "Fire Extinguisher", status: "", acceptReject: "Pending", remarks: "" },
    { no: 32, item: "Telecom switch", status: "", acceptReject: "Pending", remarks: "" },
    { no: 33, item: "Telephone Lines", status: "", acceptReject: "Pending", remarks: "" },
    { no: 34, item: "Telecom Ports", status: "", acceptReject: "Pending", remarks: "" },
    { no: 35, item: "Electric Wire Installation", status: "", acceptReject: "Pending", remarks: "" },
    { no: 36, item: "Power Supply Panels", status: "", acceptReject: "Pending", remarks: "" },
    { no: 37, item: "Transformer", status: "", acceptReject: "Pending", remarks: "" },
    { no: 38, item: "Power meter reading", status: "", acceptReject: "Pending", remarks: "" },
    { no: 39, item: "Water Meter Readings", status: "", acceptReject: "Pending", remarks: "" },
    { no: 40, item: "Other (if any)", status: "", acceptReject: "Pending", remarks: "" },
  ]);

  const [signatures, setSignatures] = useState({
    ipdc_vice_name: "", ipdc_vice_position: "", ipdc_vice_signature: "", ipdc_vice_date: "",
    investor_name: "", investor_position: "", investor_signature: "", investor_date: "",
    ipdc_kisez_name: "", ipdc_kisez_position: "", ipdc_kisez_signature: "", ipdc_kisez_date: "",
    witness1_name: "", witness1_signature: "", witness1_date: "",
    witness2_name: "", witness2_signature: "", witness2_date: "",
    witness3_name: "", witness3_signature: "", witness3_date: ""
  });

  const [isSaving, setIsSaving] = useState(false);
  const [additionalInfo, setAdditionalInfo] = useState({
    shadeOwner: "", shadeName: "", handoverDate: "", totalArea: ""
  });

  useEffect(() => {
    if (handoverId) {
      const fetchHandoverDetails = async () => {
        try {
          const handoverData = await GetDataFromApiWithParams(`parks/handover/${handoverId}`, {});
          if (handoverData) {
            setAdditionalInfo(prev => ({ ...prev, handoverDate: handoverData.handover_date || "" }));
          }
        } catch (error) { console.error(error); }
      };
      fetchHandoverDetails();
    }
  }, [handoverId]);

  useEffect(() => {
    if (selectedAgreement) {
      setAdditionalInfo(prev => ({
        ...prev,
        shadeName: selectedAgreement.shed_number || selectedAgreement.name || "",
        totalArea: selectedAgreement.total_area || selectedAgreement.area || "",
        shadeOwner: selectedAgreement.investor_name || selectedAgreement.organization_name || "",
      }));
    }
  }, [selectedAgreement]);

  const handleStatusChange = (no, val) => setChecklistItems(prev => prev.map(i => i.no === no ? { ...i, status: val } : i));
  const handleAcceptRejectChange = (no, val) => setChecklistItems(prev => prev.map(i => i.no === no ? { ...i, acceptReject: val } : i));
  const handleRemarksChange = (no, val) => setChecklistItems(prev => prev.map(i => i.no === no ? { ...i, remarks: val } : i));
  const handleSignatureChange = (field, val) => setSignatures(prev => ({ ...prev, [field]: val }));
  const handleAdditionalInfoChange = (field, val) => setAdditionalInfo(prev => ({ ...prev, [field]: val }));

const handleSaveChecklist = async () => {
  if (!handoverId) { 
    toast.error("Please save handover details first"); 
    return; 
  }
  
  setIsSaving(true);
  try {
    // Extract the actual ID if handoverId is an object or array
    const actualHandoverId = handoverId.id || (Array.isArray(handoverId) ? handoverId[0]?.id : handoverId) || handoverId;
    
    console.log("Saving with handover ID:", actualHandoverId);
    
    // 1. Save signatures
    await ExecutePostWithParams(`parks/shed-inspection-signatures`, { 
      handover_id: actualHandoverId,  // Send as simple value
      ...signatures 
    });
    
    // 2. Save checklist items
    await ExecutePostWithParams(`parks/handover-checklist-items`, { 
      handover_id: actualHandoverId,  // Send as simple value
      checklist_items: checklistItems.map(item => ({ 
        inspection_no: item.no, 
        item_name: item.item, 
        status: item.status || '', 
        accept_reject: item.acceptReject || 'Pending', 
        remarks: item.remarks || '' 
      })) 
    });
    
    // 3. Save additional info
    await ExecutePostWithParams(`parks/shed-additional-info`, { 
      handover_id: actualHandoverId,  // Send as simple value
      shade_owner: additionalInfo.shadeOwner,
      shade_name: additionalInfo.shadeName,
      total_area: additionalInfo.totalArea,
      handover_date: additionalInfo.handoverDate
    });
    
    toast.success("All data saved successfully!");
    if (onSave) onSave();
  } catch (error) { 
    console.error("Error saving checklist:", error);
    toast.error("Failed to save checklist: " + (error.response?.data?.message || error.message)); 
  } finally { 
    setIsSaving(false); 
  }
};

  // Print header component for all pages
  const PrintHeader = ({ pageNumber }) => (
    <div className="print-header" style={{ display: 'none' }}>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        width: '100%', 
        mb: 0.8, 
        pb: 0.5, 
        borderBottom: '2px solid #1a237e' 
      }}>
        <Box sx={{ width: '65px' }}>
          <img src={EthiopiaLogo} alt="Ethiopia Logo" style={{ width: '100%', height: 'auto' }} />
        </Box>
        <Box sx={{ textAlign: 'center', flex: 1, px: 2 }}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '14pt' }}>THE FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA</Typography>
          <Typography sx={{ fontWeight: 'bold', fontSize: '13pt' }}>INDUSTRIAL PARKS DEVELOPMENT CORPORATION (IPDC)</Typography>
          <Typography sx={{ fontWeight: 'bold', textDecoration: 'underline', fontSize: '12pt', mt: 0.3 }}>SHED HANDOVER INSPECTION CHECKLIST</Typography>
        </Box>
        <Box sx={{ width: '65px' }}>
          <img src={IPDCLogo} alt="IPDC Logo" style={{ width: '100%', height: 'auto' }} />
        </Box>
      </Box>
      <Typography sx={{ fontSize: '9pt', textAlign: 'right', mb: 0.3 }}>
        Page {pageNumber} of 2
      </Typography>
    </div>
  );

  const handlePrint = () => window.print();

  // Split checklist items for two pages: 1-25 on page 1, 26-40 on page 2
  const page1Items = checklistItems.slice(0, 25);
  const page2Items = checklistItems.slice(25);

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <PrintStyle />
      
      {/* Headers for both pages */}
      <PrintHeader pageNumber={1} />
      {/* <div className="print-header" style={{ display: 'none' }}>
        {/* <div className="page-break-before"></div> */}
        {/* <PrintHeader pageNumber={2} /> */}
      {/* </div>  */}
      
      <Box className="no-print" sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, gap: 1 }}>
        <Button variant="outlined" startIcon={<Print />} onClick={handlePrint} size="medium">Print Form</Button>
        <Button variant="outlined" startIcon={<Download />} size="medium">Export PDF</Button>
      </Box>

      {/* Screen - Input fields */}
      <Card sx={{ mb: 2, p: 1.5 }} className="no-print">
        <Grid container spacing={1.5}>
          <Grid item xs={6}><TimesTextField label="SHADE OWNER" fullWidth size="small" value={additionalInfo.shadeOwner} onChange={(e) => handleAdditionalInfoChange('shadeOwner', e.target.value)} /></Grid>
          <Grid item xs={6}><TimesTextField label="SHADE NAME" fullWidth size="small" value={additionalInfo.shadeName} onChange={(e) => handleAdditionalInfoChange('shadeName', e.target.value)} /></Grid>
          <Grid item xs={6}><TimesTextField label="HAND OVER DATE" type="date" fullWidth size="small" value={additionalInfo.handoverDate} onChange={(e) => handleAdditionalInfoChange('handoverDate', e.target.value)} InputLabelProps={{ shrink: true }} /></Grid>
          <Grid item xs={6}><TimesTextField label="TOTAL AREA (sq. meters)" fullWidth size="small" value={additionalInfo.totalArea} onChange={(e) => handleAdditionalInfoChange('totalArea', e.target.value)} /></Grid>
        </Grid>
      </Card>

      {/* Print-only header info */}
      <div className="print-header" style={{ display: 'none', marginBottom: '6px' }}>
        <Box sx={{ border: '1px solid #000', p: 0.8, mb: 0.8 }}>
          <Grid container spacing={0.8}>
            <Grid item xs={6}><Typography sx={{ fontSize: '12pt' }}><strong>SHADE OWNER:</strong> {additionalInfo.shadeOwner || '________________________'}</Typography></Grid>
            <Grid item xs={6}><Typography sx={{ fontSize: '12pt' }}><strong>SHADE NAME:</strong> {additionalInfo.shadeName || '________________________'}</Typography></Grid>
            <Grid item xs={6}><Typography sx={{ fontSize: '12pt' }}><strong>HAND OVER DATE:</strong> {additionalInfo.handoverDate || '________________________'}</Typography></Grid>
            <Grid item xs={6}><Typography sx={{ fontSize: '12pt' }}><strong>TOTAL AREA:</strong> {additionalInfo.totalArea ? `${additionalInfo.totalArea} sq. m` : '________________________'}</Typography></Grid>
          </Grid>
        </Box>
      </div>

      {/* PAGE 1 - Items 1 to 25 */}
      <TableContainer component={Paper} elevation={1} sx={{ overflowX: 'auto', mb: 2 }}>
        <Table size="small" className="print-table" sx={{ tableLayout: 'fixed', '& .MuiTableCell-root': { fontSize: '0.75rem', py: 0.4, px: 0.6 } }}>
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ width: '6%' }}>No.</StyledTableCell>
              <StyledTableCell sx={{ width: '32%' }}>LIST TO BE INSPECTED</StyledTableCell>
              <StyledTableCell sx={{ width: '20%' }}>STATUS</StyledTableCell>
              <StyledTableCell sx={{ width: '16%' }}>ACCEPT/REJECT</StyledTableCell>
              <StyledTableCell sx={{ width: '26%' }}>REMARKS</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {page1Items.map((row) => (
              <TableRow key={row.no}>
                <TableCell sx={{ fontSize: '0.75rem', py: 0.4 }}>{row.no}</TableCell>
                <TableCell sx={{ fontSize: '0.75rem', py: 0.4 }}>{row.item}</TableCell>
                <TableCell sx={{ py: 0.4 }}>
                  <TextField size="small" fullWidth multiline minRows={1} maxRows={2} value={row.status} onChange={(e) => handleStatusChange(row.no, e.target.value)} placeholder="Status" sx={{ '& .MuiInputBase-root': { fontSize: '0.7rem' } }} />
                </TableCell>
                <TableCell sx={{ py: 0.4 }}>
                  <FormControl size="small" fullWidth>
                    <Select value={row.acceptReject} onChange={(e) => handleAcceptRejectChange(row.no, e.target.value)} sx={{ fontSize: '0.7rem', height: '30px' }}>
                      <MenuItem value="Accept" sx={{ fontSize: '0.7rem' }}>Accept</MenuItem>
                      <MenuItem value="Reject" sx={{ fontSize: '0.7rem' }}>Reject</MenuItem>
                      <MenuItem value="Pending" sx={{ fontSize: '0.7rem' }}>Pending</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell sx={{ py: 0.4 }}>
                  <TextField size="small" fullWidth multiline minRows={1} maxRows={2} value={row.remarks} onChange={(e) => handleRemarksChange(row.no, e.target.value)} placeholder="Remarks" sx={{ '& .MuiInputBase-root': { fontSize: '0.7rem' } }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* PAGE 2 - Items 26 to 40 */}
      <div className="print-only" style={{ display: 'none' }}>
        <div className="page-break-before"></div>
        <PrintHeader pageNumber={2} />
      </div>
      
      <TableContainer component={Paper} elevation={1} sx={{ overflowX: 'auto', mt: 1 }}>
        <Table size="small" className="print-table" sx={{ tableLayout: 'fixed', '& .MuiTableCell-root': { fontSize: '0.75rem', py: 0.4, px: 0.6 } }}>
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ width: '6%' }}>No.</StyledTableCell>
              <StyledTableCell sx={{ width: '32%' }}>LIST TO BE INSPECTED</StyledTableCell>
              <StyledTableCell sx={{ width: '20%' }}>STATUS</StyledTableCell>
              <StyledTableCell sx={{ width: '16%' }}>ACCEPT/REJECT</StyledTableCell>
              <StyledTableCell sx={{ width: '26%' }}>REMARKS</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {page2Items.map((row) => (
              <TableRow key={row.no}>
                <TableCell sx={{ fontSize: '0.75rem', py: 0.4 }}>{row.no}</TableCell>
                <TableCell sx={{ fontSize: '0.75rem', py: 0.4 }}>{row.item}</TableCell>
                <TableCell sx={{ py: 0.4 }}>
                  <TextField size="small" fullWidth multiline minRows={1} maxRows={2} value={row.status} onChange={(e) => handleStatusChange(row.no, e.target.value)} placeholder="Status" sx={{ '& .MuiInputBase-root': { fontSize: '0.7rem' } }} />
                </TableCell>
                <TableCell sx={{ py: 0.4 }}>
                  <FormControl size="small" fullWidth>
                    <Select value={row.acceptReject} onChange={(e) => handleAcceptRejectChange(row.no, e.target.value)} sx={{ fontSize: '0.7rem', height: '30px' }}>
                      <MenuItem value="Accept" sx={{ fontSize: '0.7rem' }}>Accept</MenuItem>
                      <MenuItem value="Reject" sx={{ fontSize: '0.7rem' }}>Reject</MenuItem>
                      <MenuItem value="Pending" sx={{ fontSize: '0.7rem' }}>Pending</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell sx={{ py: 0.4 }}>
                  <TextField size="small" fullWidth multiline minRows={1} maxRows={2} value={row.remarks} onChange={(e) => handleRemarksChange(row.no, e.target.value)} placeholder="Remarks" sx={{ '& .MuiInputBase-root': { fontSize: '0.7rem' } }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Print Signatures - appears at the end of page 2 */}
      <div className="print-header" style={{ display: 'none', marginTop: '10px' }}>
        <Grid container spacing={2} sx={{ mb: 0.8 }}>
          <Grid item xs={4}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '12pt' }}>IPDC Vice E & Technic Manager</Typography>
            <Typography sx={{ fontSize: '10.5pt' }}>Name: {signatures.ipdc_vice_name || '____________________'}</Typography>
            <Typography sx={{ fontSize: '10.5pt' }}>Position: {signatures.ipdc_vice_position || '____________________'}</Typography>
            <Typography sx={{ fontSize: '10.5pt' }}>Signature: ____________________</Typography>
            <Typography sx={{ fontSize: '10.5pt' }}>Date: {signatures.ipdc_vice_date || '____________________'}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '12pt' }}>Investor Company</Typography>
            <Typography sx={{ fontSize: '10.5pt' }}>Name: {signatures.investor_name || '____________________'}</Typography>
            <Typography sx={{ fontSize: '10.5pt' }}>Position: {signatures.investor_position || '____________________'}</Typography>
            <Typography sx={{ fontSize: '10.5pt' }}>Signature: ____________________</Typography>
            <Typography sx={{ fontSize: '10.5pt' }}>Date: {signatures.investor_date || '____________________'}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '12pt' }}>IPDC KISEZ Manager</Typography>
            <Typography sx={{ fontSize: '10.5pt' }}>Name: {signatures.ipdc_kisez_name || '____________________'}</Typography>
            <Typography sx={{ fontSize: '10.5pt' }}>Position: {signatures.ipdc_kisez_position || '____________________'}</Typography>
            <Typography sx={{ fontSize: '10.5pt' }}>Signature: ____________________</Typography>
            <Typography sx={{ fontSize: '10.5pt' }}>Date: {signatures.ipdc_kisez_date || '____________________'}</Typography>
          </Grid>
        </Grid>
        <Box sx={{ mt: 0.8 }}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '12pt' }}>WITNESS</Typography>
          <Typography sx={{ fontSize: '10.5pt' }}>1. Name: {signatures.witness1_name || '____________________'} &nbsp;&nbsp; Signature: ____________________ &nbsp;&nbsp; Date: {signatures.witness1_date || '__________'}</Typography>
          <Typography sx={{ fontSize: '10.5pt' }}>2. Name: {signatures.witness2_name || '____________________'} &nbsp;&nbsp; Signature: ____________________ &nbsp;&nbsp; Date: {signatures.witness2_date || '__________'}</Typography>
          <Typography sx={{ fontSize: '10.5pt' }}>3. Name: {signatures.witness3_name || '____________________'} &nbsp;&nbsp; Signature: ____________________ &nbsp;&nbsp; Date: {signatures.witness3_date || '__________'}</Typography>
        </Box>
      </div>

      {/* Screen Signatures */}
      <Box sx={{ mt: 2 }} className="no-print">
        <Typography variant="subtitle1" sx={{ mb: 1 }}>Signatures</Typography>
        <Grid container spacing={1.5}>
          <Grid item xs={4}>
            <Card sx={{ p: 1 }}><Typography variant="subtitle2" fontWeight="bold">IPDC Vice E & Technic Manager</Typography>
              <TextField size="small" fullWidth label="Name" value={signatures.ipdc_vice_name} onChange={(e) => handleSignatureChange('ipdc_vice_name', e.target.value)} sx={{ my: 0.5 }} />
              <TextField size="small" fullWidth label="Position" value={signatures.ipdc_vice_position} onChange={(e) => handleSignatureChange('ipdc_vice_position', e.target.value)} sx={{ my: 0.5 }} />
              <TextField size="small" fullWidth label="Signature" value={signatures.ipdc_vice_signature} InputProps={{ readOnly: true }} sx={{ my: 0.5, bgcolor: '#f5f5f5' }} />
              <TextField size="small" fullWidth type="date" label="Date" InputLabelProps={{ shrink: true }} value={signatures.ipdc_vice_date} onChange={(e) => handleSignatureChange('ipdc_vice_date', e.target.value)} />
            </Card>
          </Grid>
          <Grid item xs={4}>
            <Card sx={{ p: 1 }}><Typography variant="subtitle2" fontWeight="bold">Investor Company</Typography>
              <TextField size="small" fullWidth label="Name" value={signatures.investor_name} onChange={(e) => handleSignatureChange('investor_name', e.target.value)} sx={{ my: 0.5 }} />
              <TextField size="small" fullWidth label="Position" value={signatures.investor_position} onChange={(e) => handleSignatureChange('investor_position', e.target.value)} sx={{ my: 0.5 }} />
              <TextField size="small" fullWidth label="Signature" value={signatures.investor_signature} InputProps={{ readOnly: true }} sx={{ my: 0.5, bgcolor: '#f5f5f5' }} />
              <TextField size="small" fullWidth type="date" label="Date" InputLabelProps={{ shrink: true }} value={signatures.investor_date} onChange={(e) => handleSignatureChange('investor_date', e.target.value)} />
            </Card>
          </Grid>
          <Grid item xs={4}>
            <Card sx={{ p: 1 }}><Typography variant="subtitle2" fontWeight="bold">IPDC KISEZ Manager</Typography>
              <TextField size="small" fullWidth label="Name" value={signatures.ipdc_kisez_name} onChange={(e) => handleSignatureChange('ipdc_kisez_name', e.target.value)} sx={{ my: 0.5 }} />
              <TextField size="small" fullWidth label="Position" value={signatures.ipdc_kisez_position} onChange={(e) => handleSignatureChange('ipdc_kisez_position', e.target.value)} sx={{ my: 0.5 }} />
              <TextField size="small" fullWidth label="Signature" value={signatures.ipdc_kisez_signature} InputProps={{ readOnly: true }} sx={{ my: 0.5, bgcolor: '#f5f5f5' }} />
              <TextField size="small" fullWidth type="date" label="Date" InputLabelProps={{ shrink: true }} value={signatures.ipdc_kisez_date} onChange={(e) => handleSignatureChange('ipdc_kisez_date', e.target.value)} />
            </Card>
          </Grid>
        </Grid>
        <Card sx={{ mt: 1.5, p: 1 }}>
          <Typography variant="subtitle2" fontWeight="bold">Witnesses</Typography>
          <Box sx={{ display: 'flex', gap: 1, mb: 1, alignItems: 'center' }}><Typography sx={{ minWidth: 25 }}>1.</Typography><TextField size="small" fullWidth label="Name" value={signatures.witness1_name} onChange={(e) => handleSignatureChange('witness1_name', e.target.value)} /><TextField size="small" fullWidth label="Signature" value={signatures.witness1_signature} InputProps={{ readOnly: true }} sx={{ bgcolor: '#f5f5f5' }} /><TextField size="small" fullWidth type="date" label="Date" InputLabelProps={{ shrink: true }} value={signatures.witness1_date} onChange={(e) => handleSignatureChange('witness1_date', e.target.value)} /></Box>
          <Box sx={{ display: 'flex', gap: 1, mb: 1, alignItems: 'center' }}><Typography sx={{ minWidth: 25 }}>2.</Typography><TextField size="small" fullWidth label="Name" value={signatures.witness2_name} onChange={(e) => handleSignatureChange('witness2_name', e.target.value)} /><TextField size="small" fullWidth label="Signature" value={signatures.witness2_signature} InputProps={{ readOnly: true }} sx={{ bgcolor: '#f5f5f5' }} /><TextField size="small" fullWidth type="date" label="Date" InputLabelProps={{ shrink: true }} value={signatures.witness2_date} onChange={(e) => handleSignatureChange('witness2_date', e.target.value)} /></Box>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}><Typography sx={{ minWidth: 25 }}>3.</Typography><TextField size="small" fullWidth label="Name" value={signatures.witness3_name} onChange={(e) => handleSignatureChange('witness3_name', e.target.value)} /><TextField size="small" fullWidth label="Signature" value={signatures.witness3_signature} InputProps={{ readOnly: true }} sx={{ bgcolor: '#f5f5f5' }} /><TextField size="small" fullWidth type="date" label="Date" InputLabelProps={{ shrink: true }} value={signatures.witness3_date} onChange={(e) => handleSignatureChange('witness3_date', e.target.value)} /></Box>
        </Card>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }} className="no-print">
        <Button variant="contained" color="primary" startIcon={isSaving ? <CircularProgress size={18} /> : <Save />} onClick={handleSaveChecklist} disabled={isSaving || !handoverId} size="medium">
          {isSaving ? "Saving..." : "Save Inspection Checklist"}
        </Button>
      </Box>
      {!handoverId && <Typography sx={{ color: 'error.main', fontSize: '0.8rem', textAlign: 'center', mt: 1 }} className="no-print">Please register handover details in Tab 1 first</Typography>}
    </Paper>
  );
}

// ========== MAIN COMPONENT ==========
export default function InspectionManagement() {
  const [tabValue, setTabValue] = useState(0);
  const [currentHandoverId, setCurrentHandoverId] = useState(null);
  const [selectedAgreement, setSelectedAgreement] = useState(null);

  const handleTabChange = (event, newValue) => setTabValue(newValue);
  const handleHandoverSaved = (handoverId, agreement) => {
    setCurrentHandoverId(handoverId);
    setSelectedAgreement(agreement);
    toast.success("Handover registered successfully!");
    setTabValue(1);
  };
  const handleChecklistSaved = () => toast.success("All data saved successfully!");

  return (
    <Box sx={{ flexGrow: 1 }}>
      <PrintStyle />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className="no-print">
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab icon={<Verified />} label="Register Handover" iconPosition="start" />
          <Tab icon={<Assignment />} label="Complete Shed Checklist" iconPosition="start" />
        </Tabs>
      </Box>
      <TabPanel value={tabValue} index={0}>
        <RegisterHandoverTab onHandoverSaved={handleHandoverSaved} />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <CombinedChecklistTab handoverId={currentHandoverId} onSave={handleChecklistSaved} selectedAgreement={selectedAgreement} />
      </TabPanel>
    </Box>
  );
}